import gql from "graphql-tag";
import { offeredFragment } from "@/graphql/offered/fragments";

export const CREATE_OFFERED = gql`
  mutation createOffered(
    $projectId: ID!
    $amountNet: Int!
    $date: Date!
    $comment: String
    $creditNoteFor: ID
  ) {
    createOffered(
      projectId: $projectId
      amountNet: $amountNet
      date: $date
      comment: $comment
      creditNoteFor: $creditNoteFor
    ) {
      status
      error
      data {
        ...OfferedFragment
      }
    }
  }
  ${offeredFragment}
`;

export const DELETE_OFFERED = gql`
  mutation deleteOffered($id: ID!) {
    deleteOffered(id: $id) {
      status
      error
      data {
        ...OfferedFragment
      }
    }
  }
  ${offeredFragment}
`;

export const UPDATE_OFFERED = gql`
  mutation updateOffered(
    $id: ID!
    $amountNet: Int!
    $date: Date!
    $comment: String
  ) {
    updateOffered(
      id: $id
      amountNet: $amountNet
      date: $date
      comment: $comment
    ) {
      status
      error
      data {
        ...OfferedFragment
      }
    }
  }
  ${offeredFragment}
`;

export const SET_OFFERED_VALIDATION = gql`
  mutation setOfferedValidation($id: ID!, $validated: Boolean!) {
    setOfferedValidation(id: $id, validated: $validated) {
      status
      error
      data {
        ...OfferedFragment
      }
    }
  }
  ${offeredFragment}
`;
